// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1zxeW","detailsBorder":"styles_detailsBorder__1swae"};